const MENU_ENVIRONMENT = process.env?.VUE_APP_MENU_ENVIRONMENT;

export default {
  head: {
    title: {
      separator: '|',
      complement: MENU_ENVIRONMENT ? `[${MENU_ENVIRONMENT}] 蔵-建設DX2022` : `蔵-建設DX2022`,
    },
  },
}